import {gql} from '@apollo/client';
import {CustomerComplaintHqListFilter} from '../types/CustomerComplaintType';

/** 导出 DSP 申诉汇总（仅 HQ 视角）：异步生成，去下载中心领取；导出列与页面列表一致。 */
export const GENERATE_CUSTOMER_COMPLAINT_DOWNLOAD_REPORT = gql`
    mutation GenerateCustomerComplaintDownloadReportForHq(
        $filter: CustomerComplaintHqListFilterInput!,
        $language: String,
        $timezone: String
    ) {
        generateCustomerComplaintDownloadReportForHq(
            filter: $filter,
            language: $language,
            timezone: $timezone
        ) {
            success
            errorCode
            fileName
        }
    }
`;

export interface GenerateCustomerComplaintDownloadReportResponse {
    generateCustomerComplaintDownloadReportForHq: {
        success: boolean;
        /** NO_DATA / EXCEED_MAX_LIMIT:<n> / DOWNLOAD_FAILED */
        errorCode?: string | null;
        fileName?: string | null;
    };
}

export interface GenerateCustomerComplaintDownloadReportVariables {
    filter: CustomerComplaintHqListFilter;
    language?: string;
    timezone?: string;
}
